<script>
  import Service from '../../../domain/chat/services/chat'
  import {mapGetters} from 'vuex'
  import ChatUsuarioItem from './ChatUsuarioItem'
  import ChatConversa from './ChatConversa.vue'
  import Vue from 'vue'
  //  import { findIndex } from 'lodash'
  export default {
    name: 'u-chat-usuarios',
    props: {
      filterKey: String
    },
    data () {
      return {
        usuarios: null,
        countMessages: []
      }
    },
    computed: {
      ...mapGetters(['currentUser', 'isChatOpened']),
      filteredData: function () {
        let filterKey = this.filterKey && this.filterKey.toLowerCase()
        let data = this.usuarios
        if (filterKey) {
          data = data.filter(function (row) {
            return Object.keys(row).some(function (key) {
              return String(row[key]).toLowerCase().indexOf(filterKey) > -1
            })
          })
        }
        return data
      }
    },
    mounted () {
      this.online()
      this._conversas = []
      this._interval = null
      // this.getCountMessages()
    },
    destroyed () {
    },
    watch: {
      isChatOpened: function (val) {
      }
    },
    methods: {
      online () {
        Service.online().then(result => {
          this.usuarios = result.data
        })
          .catch(error => {
            console.log(error.response)
          })
      },
      openChat (user) {
        window.setTimeout(() => {
          user.naoLidas = 0
        }, 1000)
        if (this.chatIsOpened(user)) {
          this._conversas[user.id].shake()
          return
        }
        let _chatConversa = Vue.extend(ChatConversa)
        this._conversas[user.id] = new _chatConversa({
          propsData: {
            currentUser: this.currentUser,
            destUser: user
          }
        }).$mount()
        this._conversas[user.id].$on('close', this.closeChatWindow)
        this.$root.$el.querySelector('#chat-conversas-container').appendChild(this._conversas[user.id].$el)
      },
      closeChatWindow (chat) {
        if (typeof this._conversas[chat.id] === 'undefined') {
          console.log('Window does not exists.')
          return
        }
        if (this.$root.$el.querySelector('#chat-conversas-container').contains(this._conversas[chat.id].$el)) this.$root.$el.querySelector('#chat-conversas-container').removeChild(this._conversas[chat.id].$el)
        this._conversas[chat.id].$destroy()
        delete this._conversas[chat.id]
      },
      chatIsOpened (user) {
        return typeof this._conversas[user.id] !== 'undefined'
      },
      updateNotReaded (mensagens) {
        if (typeof this.usuarios === 'undefined') {
          return
        }
        if (this.usuarios === null) {
          return
        }
        mensagens.forEach((mensagem, index) => {
          this.usuarios.forEach((usuario, index) => {
            if (Number(usuario.id) === Number(mensagem.usuario)) {
              if (this.chatIsOpened(usuario)) {
                this._conversas[usuario.id].reload()
              } else {
                this.usuarios[index].naoLidas = mensagem.naoLidas
                this.openChat(this.usuarios[index])
              }
            }
          })
        })
      }
    },
    components: {ChatUsuarioItem}
  }
</script>

<template>
  <div>
    <!--<ul class="list-group no-borders pull-in auto">
      <li class="list-group-item" v-for="usuario in usuarios">
                <span class="pull-left thumb-sm avatar m-r">
          <img src="~assets/img/user-default.png" :alt="usuario.nome" class="img-circle">
          <i class="on b-white bottom"></i></span>
        <a @click="$store.dispatch('abrirChat', usuario)" class="text-muted active"><i
          class="fas fa-comment-o pull-right m-t-sm text-sm"></i></a>
        <div class="clear">
          <div><a>{{ usuario.nome }} <span class="font-thin" v-if="usuario.id == currentUser.id">(você)</span></a></div>
          <b class="badge bg-info pull-right" v-show="usuario.naolidos != 0">{{ usuario.naolidos = findByRemetente(usuario.id) }}</b>
          <small class="text-muted">{{ usuario.ultimoAcesso.date | moment }}</small>
        </div>
      </li>
    </ul>-->
    <!--<div class="text-center">
      <a href="" class="btn btn-sm btn-primary padder-md m-b">Mais conversas</a>
    </div>-->

    <a href="#openChat" @click.prevent="openChat(usuario)" v-for="usuario in filteredData">
      <chat-usuario-item :usuario="usuario" :currentUser="currentUser"></chat-usuario-item>
    </a>

  </div>
</template>



// WEBPACK FOOTER //
// ChatUsuarios.vue?0a52b7c6